import { Box, Card, CardContent, Tooltip, Typography } from "@mui/material"
import { IFeatureDriftCard } from "../util/interface"
import { createUseStyles, useTheme } from "react-jss"
import info from "../icons/info.svg"
import Warning from "../icons/WarningFD.svg"
import CustomIcon from "./CustomIcon"
import CustomProgressFD from "./CustomProgressFD"

const useStyles = createUseStyles({
  wrapper: {
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    display: "flex",
    flexDirection: "column",
    gap: 9,
  },
  headerWrapper: {
    display: "grid",
    gridTemplateColumns: "93% 7%",
    alignItems: "center",
    justifyContent: "center",
    height: 30,
    textAlign: "center",
  },
  header: {
    color: "#5C5C5C",
    fontSize: 12,
    justifySelf: "center",
    fontWeight: ({ activeTab, cardKey }: any) =>
      activeTab === cardKey ? "bolder" : "normal",
  },
  value: {
    color: "black",
  },
  info: {
    justifySelf: "flex-end",
  },
  progress: {
    display: "flex",
    justifyContent: "center",
    marginLeft: 20,
  },
  bodyWrapper: {
    display: "grid",
    gridTemplateColumns: "90% 10%",
  },
  email: {
    alignSelf: "flex-end",
  },
  card: {
    minWidth: 180,
    minHeight: 160,
    height: "100%",
    padding: 0,
    cursor: "pointer",
    boxShadow: ({ activeTab, cardKey }: any) =>
      activeTab === cardKey
        ? "0px 2px 8px 0px #F6BB42"
        : "0px 2px 4px 0px #00000040",
    border: ({ activeTab, cardKey }: any) =>
      activeTab === cardKey ? "2px solid #F6BB4266" : "none",
  },
  cardContent: {
    padding: "5px",
    paddingBottom: "20px !important",
  },
})

export const FeatureDriftCard = ({
  cardDetails,
  activeTab,
}: {
  cardDetails: IFeatureDriftCard
  activeTab: string
}) => {
  const theme: any = useTheme()

  const classes = useStyles({ theme, activeTab, cardKey: cardDetails.key })

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <div className={classes.wrapper}>
          <div className={classes.headerWrapper}>
            <h3 className={classes.header}>{cardDetails.title}</h3>
            <Tooltip title={cardDetails.toolTipText}>
              <div className={classes.info}>
                <CustomIcon path={info}></CustomIcon>
              </div>
            </Tooltip>
          </div>
          <Box textAlign={"center"} display={"flex"} justifyContent={"center"}>
            <CustomIcon path={Warning}></CustomIcon>
            <Typography variant="caption">
              Warnings: {cardDetails.warnings}
            </Typography>
          </Box>
          <div className={classes.bodyWrapper}>
            <div className={classes.progress}>
              <CustomProgressFD
                isActive={activeTab === cardDetails.key}
                isFull={cardDetails.progress === 100}
                progress={cardDetails.progress}
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
